import React, { Fragment } from "react";
import moment from "moment";
import * as utilities from "../../utilities/utils";
import StdAcmdModalComponent from "./StdAcmdCaseDetailsComponent";
import AirCaseDetailComponent from "./AirCaseDetailComponent";
import { CASE_STATUS } from "../../App.config";
import AccCaseDetailComponent from "./AccCaseDetailComponent";

const AllCaseDetailModalComponent = (props) => {

  return (
    <>
      {
        props.caseDetail[0].isAIR
          ?
          <AirCaseDetailComponent caseInfo={props} {...props} />
          :
          (CASE_STATUS.isAccomodation(CASE_STATUS.getInitialStatus(props.caseDetail[0].fileStatusInformation, props.caseDetail[0].fileStatus)) || CASE_STATUS.isCCM(CASE_STATUS.getInitialStatus(props.caseDetail[0].fileStatusInformation, props.caseDetail[0].fileStatus))) ?
            <AccCaseDetailComponent caseInfo={props} {...props} />
            :
            <StdAcmdModalComponent caseInfo={props} {...props} />
      }
    </>

  );
};
export default AllCaseDetailModalComponent;
